// <!-- GRACE:MODULE_START name="ui_asr" -->
// <!-- GRACE:DEPENDENCY target="ui_types" -->
import React, { useRef } from 'react';
import { CloudArrowUpIcon } from '@heroicons/react/24/outline';

interface AudioUploadButtonProps {
  onFileSelect: (file: File) => void;
  disabled?: boolean;
}

// <!-- GRACE:CONTRACT function="AudioUploadButton" -->
const AudioUploadButton: React.FC<AudioUploadButtonProps> = ({
  onFileSelect, 
  disabled = false 
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      // Проверяем расширение файла
      const allowedExtensions = ['.m4a', '.mp3', '.wav', '.ogg', '.webm', '.aac', '.flac', '.wma', '.waptt.opus'];
      const fileName = file.name.toLowerCase();
      
      // Проверяем точное совпадение с разрешенными расширениями
      const isAllowed = allowedExtensions.some(ext => fileName.endsWith(ext));
      
      if (!isAllowed) {
        alert('Пожалуйста, выберите аудио файл (M4A, MP3, WAV, OGG, WebM, AAC, FLAC, WMA, WAPTT.OPUS)');
        return;
      }

      onFileSelect(file);
    }
  };

  const handleClick = () => {
    if (!disabled) {
      fileInputRef.current?.click();
    }
  };

  return (
    <div className="text-center">
      <input
        ref={fileInputRef}
        type="file"
        accept="audio/*,video/webm,.m4a,.mp3,.wav,.ogg,.webm,.aac,.flac,.wma,.waptt.opus"
        onChange={handleFileChange}
        className="hidden"
      />
      
      <button
        onClick={handleClick}
        disabled={disabled}
        className={`
          relative w-24 h-24 rounded-full flex items-center justify-center
          transition-all duration-300 transform hover:scale-105
          focus:outline-none focus:ring-4 focus:ring-opacity-50
          ${disabled 
            ? 'bg-gray-400 hover:bg-gray-500 focus:ring-gray-300 opacity-50 cursor-not-allowed hover:scale-100' 
            : 'bg-medical-secondary hover:bg-green-600 focus:ring-green-300 cursor-pointer'
          }
        `}
        aria-label="Загрузить аудио файл"
      >
        {/* Иконка загрузки */}
        <div className="text-white">
          <CloudArrowUpIcon className="w-8 h-8" />
        </div>

        {/* Индикатор загрузки */}
        {disabled && (
          <div className="absolute -top-2 -left-2 w-6 h-6 bg-gray-600 rounded-full flex items-center justify-center">
            <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
          </div>
        )}

        {/* Текст под кнопкой */}
        <div className="absolute -bottom-5 left-1/2 transform -translate-x-1/2 text-center">
          <p className="text-sm font-medium text-medical-text whitespace-nowrap">
            {disabled ? 'Обработка...' : 'Загрузить'}
          </p>
        </div>
      </button>
    </div>
  );
};

export default AudioUploadButton;
// <!-- GRACE:MODULE_END name="ui_asr" -->
